import { COMMANDERS } from './../LevelManager/store.d';
import { GameSceneStoreStype } from './../../a.scenes/GameScene/store';
export const SEL_GRAVESTONES = (s: GameSceneStoreStype) => s.terrain.data.gravestones
export const SEL_GRID_ORIGIN = (s: GameSceneStoreStype) => s.terrain.data.gridOrigin
export const SEL_TREASURES = (s: GameSceneStoreStype) => {
  return s.terrain.data.treasures
}
export const SEL_LEVEL_SUMMARY = (s: GameSceneStoreStype) => {
  const treasures = SEL_TREASURES(s)
  const myTreasure = treasures.find(t => t.owner === COMMANDERS.PLAYER)
  const enemyTreasure = treasures.find(t => t.owner === COMMANDERS.COM)
  const candyWon = (enemyTreasure?.amount_max ?? 0) - (enemyTreasure?.amount ?? 0)
  const candyLost = (myTreasure?.amount_max ?? 0) - (myTreasure?.amount ?? 0)
  const diff = candyWon - candyLost
  return {
    candyWon,
    candyLost,
    diff
  }
}